module.exports = __webpack_public_path__ + "static/img/andres-y-asociados-1.fc95b06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/andres-y-asociados-1.jpg
// module id = Oucc
// module chunks = 1